<template>
  <div>
    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="用户信息">
              <a-input placeholder="请输入用户名/姓名/身份证号/手机号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="注册方式">
              <a-select v-model="where.keyword.sourceType" allowClear @change="registerChange">
                <a-select-option :value="-1">个人注册</a-select-option>
                <a-select-option :value="1">系统导入</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="注册日期">
              <a-range-picker
                format="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                @change="onTimeChange"
              />
            </a-form-item>
          </a-col>
          <a-col :span="2" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
<!--    <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo(0, 1)" type="primary" />-->
      <pxkeji-btn name="下载模版" class="pxkeji_basic_btn" @click="downloadTemplate" type="primary" />
      <pxkeji-btn name="导出用户" class="pxkeji_basic_btn" @click="exportData" type="primary" />
      <a-upload
        name="file"
        :action="$api.student.importEnterpriseStudentData(list.enterpriseId)"
        accept=".xls, .xlsx"
        @change="handleChange"
        :showUploadList="false"
      >
        <a-button>
          <a-icon type="upload" />导入用户
        </a-button>
      </a-upload>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="sourceType" slot-scope="sourceType">
          <span v-if="sourceType==0">个人注册</span>
          <span v-else>系统导入</span>
        </span>

        <span slot="status" slot-scope="status">
          <a-tag v-if="status==0" color="red">禁用</a-tag>
          <a-tag v-else color="green">启用</a-tag>
        </span>

        <!-- <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="编辑"
            :roles="[]"
            @click="showInfo(action.id,2)"
            size="small"
            type="primary"
          />
          <a-divider type="vertical" />

          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                  name="积分明细"
                  :roles="[]"
                  @click="integralInfo(action)"
                  size="small"
                  type="dashed"
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                  name="重置密码"
                  :roles="[]"
                  @click="resetPaw(action.userId)"
                  size="small"
                  type="dashed"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span> -->
      </a-table>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :infos="addedit.info" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./personalInfo.vue"; //新增编辑
const columns = [
  {
    dataIndex: "fullName",
    key: "fullName",
    align: "center",
    title: "姓名"
  },
  {
    dataIndex: "sex",
    key: "sex",
    align: "center",
    title: "性别",
    scopedSlots: { customRender: "sex" }
  },

  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号"
  },

  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "添加时间"
  },
  {
    dataIndex: "sourceType",
    key: "sourceType",
    align: "center",
    title: "注册方式",
    scopedSlots: { customRender: "sourceType" }
  },
  {
    dataIndex: "company",
    key: "company",
    align: "center",
    title: "所属单位"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  // {
  //   title: "操作",
  //   key: "action",
  //   align: "center",
  //   scopedSlots: { customRender: "action" }
  // }
];
var excelLoading="";
export default {
  name: "staffList",
  props: {
    enterpriseId: String
  },
  data() {
    return {
      expand: false, //高级搜索

      list: {
          enterpriseId:"",
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      registerItem: [
        {
          value: "1",
          lable: "个人注册"
        },
        {
          value: "2",
          lable: "集体开课"
        }
      ],
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          startTime: "",
          endTime: "",
          sourceType: ""
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.list.enterpriseId=this.enterpriseId
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    groupChanged(v) {
      this.where.keyword.groupIds = v;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      var param = {
          pageNow: this.list.pagination.current,
          pageSize: this.list.pagination.defaultPageSize,
          startTime: this.where.keyword.startTime,
          endTime: this.where.keyword.endTime,
          name: this.where.keyword.name,
          enterpriseId: this.enterpriseId
        };
        if (this.where.keyword.sourceType != "") {
          param.sourceType = this.where.keyword.sourceType;
        }
      this.$api.student
        .getPagedList(param)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    registerChange(item) {
      this.where.keyword.registerSource = item;
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(id, type) {
      //打开弹出框
      if (type == 1) {
        this.addedit.title = "添加";
      } else {
        this.addedit.title = "详情";
      }
      this.addedit.visible = true;
      this.addedit.id = id;
      this.addedit.type = type;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {},
        onCancel() {}
      });
    },
    resetPaw(id, password) {
      this.$confirm({
        title: "您确定要将密码重置为111111吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.user
            .resetPassword(id, "111111")
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    save() {
      this.addedit.visible = false;
      this.integral.visible = false;
      this.GetList();
    },
    downloadTemplate() {
      window.location.href = this.$api.student.downloadEnterpriseStudentTemplate();
    },
    exportData() {
      window.location.href = this.$api.student.exportEnterpriseStudentData(
        this.where.keyword.name,
        this.where.keyword.startTime,
        this.where.keyword.endTime,
        this.where.keyword.sourceType,
        "", "","",
        this.enterpriseId,
      );
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handleChange(info) {
      if (info.file.status == "uploading") {
        if (excelLoading == "")
          excelLoading = this.$message.loading("上传中", 0);
      } else if (info.file.status == "done") {
        excelLoading();
        excelLoading = "";
        if (info.file.response.errorCode == this.$msg.responseCode.success) {
          this.$message.success(info.file.response.errorMsg);
          this.GetList();
        } else {
          this.$message.error(info.file.response.errorMsg);
        }
      }
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

